const ScalingComponent = ({ content }) => {
  return (
    <div className="transition duration-100 ease-in-out hover:scale-105 active:scale-90">
      {content}
    </div>
  )
}

export default ScalingComponent
